import { ChipOwnProps } from '@mui/material/Chip';
import { SettlementState as SettlementStateEnum } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
type PickedChipProps = Required<Pick<ChipOwnProps, 'label' | 'color'>>;

export const chipPropsBySettlementState: Record<SettlementStateEnum, PickedChipProps> = {
  [SettlementStateEnum.PENDING]: {
    label: t('status.pending'),
    color: 'info',
  },
  [SettlementStateEnum.APPROVED]: {
    label: t('status.approved'),
    color: 'success',
  },
  [SettlementStateEnum.PAID]: {
    label: t('status.done_paid'),
    color: 'success',
  },
  [SettlementStateEnum.CUSTOMER_PENDING]: {
    label: t('status.sent'),
    color: 'primary',
  },
  [SettlementStateEnum.CUSTOMER_APPROVED]: {
    label: t('status.approved'),
    color: 'success',
  },
  [SettlementStateEnum.CUSTOMER_PAID]: {
    label: t('status.done_paid'),
    color: 'success',
  },
  [SettlementStateEnum.VOIDED]: {
    label: t('status.voided'),
    color: 'primary',
  },
} as const;
